import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import type { ShortUuidIconName } from "@egalregal/shared";
import {
  faAnchor,
  faAppleWhole,
  faBasketball,
  faBell,
  faBicycle,
  faBoltLightning,
  faBurger,
  faCableCar,
  faCakeCandles,
  faCar,
  faCarrot,
  faCat,
  faClock,
  faCloudRain,
  faCookieBite,
  faCrown,
  faDog,
  faDove,
  faDragon,
  faDrum,
  faEarthAmericas,
  faEye,
  faFire,
  faFish,
  faFlag,
  faFrog,
  faFutbol,
  faGlasses,
  faGuitar,
  faHammer,
  faHand,
  faHeadphones,
  faHeart,
  faHelicopter,
  faHorse,
  faHouse,
  faIceCream,
  faKey,
  faLeaf,
  faLemon,
  faMagnifyingGlass,
  faMap,
  faMicrophone,
  faMoon,
  faPaperclip,
  faPen,
  faPhone,
  faPizzaSlice,
  faPlane,
  faRocket,
  faScissors,
  faShirt,
  faShower,
  faSnowflake,
  faSocks,
  faSpider,
  faStar,
  faSun,
  faTooth,
  faTractor,
  faTree,
  faTrophy,
  faUmbrella,
  faUtensils,
} from "@fortawesome/free-solid-svg-icons";

/**
 * Icon definitions for the 64-icon short-UUID alphabet (ADR-0027). Each
 * `fa-*` name in ICONS_64 maps to its explicit free-solid import — the list
 * here must cover exactly the names in docs/icons.md (kept tree-shaken by
 * explicit imports, repo convention).
 */
export const LABEL_ICONS = {
  "fa-anchor": faAnchor,
  "fa-apple-whole": faAppleWhole,
  "fa-basketball": faBasketball,
  "fa-bell": faBell,
  "fa-bicycle": faBicycle,
  "fa-bolt-lightning": faBoltLightning,
  "fa-burger": faBurger,
  "fa-cable-car": faCableCar,
  "fa-cake-candles": faCakeCandles,
  "fa-car": faCar,
  "fa-carrot": faCarrot,
  "fa-cat": faCat,
  "fa-clock": faClock,
  "fa-cloud-rain": faCloudRain,
  "fa-cookie-bite": faCookieBite,
  "fa-crown": faCrown,
  "fa-dog": faDog,
  "fa-dove": faDove,
  "fa-dragon": faDragon,
  "fa-drum": faDrum,
  "fa-earth-americas": faEarthAmericas,
  "fa-eye": faEye,
  "fa-fire": faFire,
  "fa-fish": faFish,
  "fa-flag": faFlag,
  "fa-frog": faFrog,
  "fa-futbol": faFutbol,
  "fa-glasses": faGlasses,
  "fa-guitar": faGuitar,
  "fa-hammer": faHammer,
  "fa-hand": faHand,
  "fa-headphones": faHeadphones,
  "fa-heart": faHeart,
  "fa-helicopter": faHelicopter,
  "fa-horse": faHorse,
  "fa-house": faHouse,
  "fa-ice-cream": faIceCream,
  "fa-key": faKey,
  "fa-leaf": faLeaf,
  "fa-lemon": faLemon,
  "fa-magnifying-glass": faMagnifyingGlass,
  "fa-map": faMap,
  "fa-microphone": faMicrophone,
  "fa-moon": faMoon,
  "fa-paperclip": faPaperclip,
  "fa-pen": faPen,
  "fa-phone": faPhone,
  "fa-pizza-slice": faPizzaSlice,
  "fa-plane": faPlane,
  "fa-rocket": faRocket,
  "fa-scissors": faScissors,
  "fa-shirt": faShirt,
  "fa-shower": faShower,
  "fa-snowflake": faSnowflake,
  "fa-socks": faSocks,
  "fa-spider": faSpider,
  "fa-star": faStar,
  "fa-sun": faSun,
  "fa-tooth": faTooth,
  "fa-tractor": faTractor,
  "fa-tree": faTree,
  "fa-trophy": faTrophy,
  "fa-umbrella": faUmbrella,
  "fa-utensils": faUtensils,
} satisfies Record<string, IconDefinition>;

/** The free-solid definition for a short-UUID icon name (ADR-0027). */
export function labelIcon(name: ShortUuidIconName): IconDefinition {
  return LABEL_ICONS[name]!;
}